var _rect, _rect2, _mask, _path, _mask2, _path2, _mask3, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 90,
    viewBox: "0 0 100 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50.6574,
    height: 45.1236,
    transform: "matrix(0.889094 -0.457725 0.413626 0.910447 0 23.1871)",
    fill: "#666770"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.00202,
    y: 2.9977,
    width: 58.9101,
    height: 54.293,
    transform: "matrix(1 -0.000764908 0.000675003 1 35.0472 29.7093)",
    fill: "#666770",
    stroke: "#F0F1F3",
    strokeWidth: 6
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_5423_3672",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4207 48.4203H89.0636V59.9201H46.4207V48.4203Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4207 52.4203H89.0636V44.4203H46.4207V52.4203Z",
    fill: "white",
    mask: "url(#path-3-inside-1_5423_3672)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_5423_3672",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4207 59.9202H89.0636V71.42H46.4207V59.9202Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4207 63.9202H89.0636V55.9202H46.4207V63.9202Z",
    fill: "white",
    mask: "url(#path-5-inside-2_5423_3672)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-3_5423_3672",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6006 31.821L45.145 13.9208L49.6679 23.8117L15.1235 41.7119L10.6006 31.821Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2641 35.4588L46.8085 17.5585L43.4816 10.2831L8.93721 28.1833L12.2641 35.4588Z",
    fill: "white",
    mask: "url(#path-7-inside-3_5423_3672)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableroIcon);
export default __webpack_public_path__ + "static/media/TableroIcon.5cb3fc68eb80a11fd1c68c79d08bede8.svg";
export { ForwardRef as ReactComponent };